import React from "react";
import { Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createBrowserHistory } from "history";
import MomentUtils from "@date-io/moment";
import { Provider as StoreProvider } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import "react-perfect-scrollbar/dist/css/styles.css";
import { theme } from "./common/theme";
import { configureStore } from "./store";
import routes from "./routes";
import { 
  // CookiesNotification, 
  ScrollReset, 
  StylesProvider } from "./components";
import "./assets/scss/main.scss";
import "./assets/scss/custom.css";
import i18n from "./common/i18n/i18n";
import { I18nextProvider } from "react-i18next";

const history = createBrowserHistory();
const store = configureStore();
console.log('ENV',process.env);

function App() {
  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <StylesProvider direction={"ltr"}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <I18nextProvider i18n={i18n}>
              <Router history={history}>
                <ScrollReset />
                {/* <CookiesNotification /> */}
                {renderRoutes(routes)}
              </Router>
            </I18nextProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </ThemeProvider>
    </StoreProvider>
  );
}

export default App;
